import * as tmsEventTemplatesApi from '../api/tmsEventTemplatesApi';
import ActionTypes from './actionTypes/index';

const {
    EVENTS_TEMPLATES_FETCH_LIST_REQUEST,
    EVENTS_TEMPLATES_FETCH_LIST_SUCCESS,
    EVENTS_TEMPLATES_FETCH_LIST_FAILURE,
    EVENTS_TEMPLATES_FETCH_REQUEST,
    EVENTS_TEMPLATES_FETCH_SUCCESS,
    EVENTS_TEMPLATES_FETCH_FAILURE,
    EVENTS_TEMPLATES_DELETE_REQUEST,
    EVENTS_TEMPLATES_DELETE_SUCCESS,
    EVENTS_TEMPLATES_DELETE_FAILURE,
    EVENTS_TEMPLATES_SAVE_REQUEST,
    EVENTS_TEMPLATES_SAVE_SUCCESS,
    EVENTS_TEMPLATES_SAVE_FAILURE,
    EVENTS_TEMPLATES_TAGS_FETCH_REQUEST,
    EVENTS_TEMPLATES_TAGS_FETCH_SUCCESS,
    EVENTS_TEMPLATES_TAGS_FETCH_FAILURE,
    EVENTS_TEMPLATES_TOURS_FETCH_REQUEST,
    EVENTS_TEMPLATES_TOURS_FETCH_SUCCESS,
    EVENTS_TEMPLATES_TOURS_FETCH_FAILURE,
    EVENTS_TEMPLATES_SET_REDIRECT_URL,
    EVENTS_TEMPLATES_SET_CLUB_ID,
} = ActionTypes;

export const fetchEventTemplateList = (initialFetch) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENTS_TEMPLATES_FETCH_LIST_REQUEST, initialFetch });
    try {
        const { templatesFetchState } = getState().eventTemplates;
        const { count, fetched } = templatesFetchState;
        const start = initialFetch ? 0 : fetched;
        const res = await tmsEventTemplatesApi.getEventTemplates(mainApi, start, count);
        const { data } = res;
        if (data.error) {
            dispatch({ type: EVENTS_TEMPLATES_FETCH_LIST_FAILURE });
        } else {
            dispatch({ type: EVENTS_TEMPLATES_FETCH_LIST_SUCCESS, data });
        }
    } catch (error) {
        dispatch({
            type: EVENTS_TEMPLATES_FETCH_LIST_FAILURE,
        });
    }
};

export const fetchClubEventTemplateList = (initialFetch, clubId, sportTypeId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENTS_TEMPLATES_FETCH_LIST_REQUEST, initialFetch });
    try {
        const { templatesFetchState } = getState().eventTemplates;
        const { count, fetched } = templatesFetchState;
        const start = initialFetch ? 0 : fetched;
        const res = await tmsEventTemplatesApi.getEventTemplatesForClub(mainApi, clubId, start, count, sportTypeId);
        const { data } = res;
        if (data.error) {
            dispatch({ type: EVENTS_TEMPLATES_FETCH_LIST_FAILURE });
        } else {
            dispatch({ type: EVENTS_TEMPLATES_FETCH_LIST_SUCCESS, data });
        }
    } catch (error) {
        dispatch({
            type: EVENTS_TEMPLATES_FETCH_LIST_FAILURE,
        });
    }
};

export const fetchEventTemplate = (templateId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENTS_TEMPLATES_FETCH_REQUEST });
    try {
        const res = await tmsEventTemplatesApi.getEventTemplate(mainApi, templateId);
        const { data } = res;
        if (data.error) {
            dispatch({ type: EVENTS_TEMPLATES_FETCH_FAILURE });
        } else {
            dispatch({ type: EVENTS_TEMPLATES_FETCH_SUCCESS, data });
        }
        return res;
    } catch (error) {
        dispatch({
            type: EVENTS_TEMPLATES_FETCH_FAILURE,
        });
    }
};

export const fetchEventTemplateTags = () => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENTS_TEMPLATES_TAGS_FETCH_REQUEST });
    try {
        const res = await tmsEventTemplatesApi.getEventTemplateTags(mainApi);
        const { data } = res;
        if (data.error) {
            dispatch({ type: EVENTS_TEMPLATES_TAGS_FETCH_FAILURE });
        } else {
            dispatch({ type: EVENTS_TEMPLATES_TAGS_FETCH_SUCCESS, data });
        }
        return res;
    } catch (error) {
        dispatch({
            type: EVENTS_TEMPLATES_TAGS_FETCH_FAILURE,
        });
    }
};

export const fetchEventTours = () => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENTS_TEMPLATES_TOURS_FETCH_REQUEST });
    try {
        const res = await tmsEventTemplatesApi.getEventTours(mainApi);
        const { data } = res;
        if (data.error) {
            dispatch({ type: EVENTS_TEMPLATES_TOURS_FETCH_FAILURE });
        } else {
            dispatch({ type: EVENTS_TEMPLATES_TOURS_FETCH_SUCCESS, data });
        }
        return res;
    } catch (error) {
        dispatch({
            type: EVENTS_TEMPLATES_TOURS_FETCH_FAILURE,
        });
    }
};

export const deleteEventTemplate = (templateId) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENTS_TEMPLATES_DELETE_REQUEST });
    try {
        await tmsEventTemplatesApi.deleteEventTemplate(mainApi, templateId);
        dispatch({ type: EVENTS_TEMPLATES_DELETE_SUCCESS });
    } catch (error) {
        dispatch({
            type: EVENTS_TEMPLATES_DELETE_FAILURE,
        });
    }
};

export const saveEventTemplate = (templateId, eventTemplateValues) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: EVENTS_TEMPLATES_SAVE_REQUEST });
    try {
        const res = await tmsEventTemplatesApi.saveEventTemplate(mainApi, templateId, eventTemplateValues);
        const { data } = res;
        if (data.error) {
            dispatch({ type: EVENTS_TEMPLATES_SAVE_FAILURE });
        } else {
            dispatch({ type: EVENTS_TEMPLATES_SAVE_SUCCESS });
        }
        return res;
    } catch (error) {
        dispatch({
            type: EVENTS_TEMPLATES_SAVE_FAILURE,
        });
    }
};

export const setRedirectUrl = (redirectUrl) => async (dispatch) => {
    dispatch({ type: EVENTS_TEMPLATES_SET_REDIRECT_URL, data: redirectUrl });
};

export const setClubId = (clubId) => async (dispatch) => {
    dispatch({ type: EVENTS_TEMPLATES_SET_CLUB_ID, data: clubId });
};
